import { render, staticRenderFns } from "./ReplacementItemReorder.vue?vue&type=template&id=605a0478"
import script from "./ReplacementItemReorder.vue?vue&type=script&lang=js"
export * from "./ReplacementItemReorder.vue?vue&type=script&lang=js"
import style0 from "./ReplacementItemReorder.vue?vue&type=style&index=0&id=605a0478&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports